export default __webpack_public_path__ + "static/media/notes-and-videos.c6b3683a.jpg";